import styled from "styled-components";
export const Header = styled.header `
  background: white;
  border-bottom: 2px solid var(--ant-primary-color);
  padding: 0px;

  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 999;
`;
export const HeaderRow = styled.div `
  line-height: var(--opendash-header-row-height);
  height: var(--opendash-header-row-height);
  width: 100%;

  &:not(:last-child) {
    border-bottom: 1px solid #eee;
    height: calc(var(--opendash-header-row-height) + 1px);
  }
`;
export const HeaderDropdown = styled.div `
  display: block;
  padding: 1px;
  background: #005493;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  top: -6px;
  position: relative;
  min-width: 302px;
  /* margin-left: -10px; */

  ::before {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #005493;
    content: "";
    position: absolute;
    top: -5px;
    left: ${(p) => (p.right ? "auto" : "18px")};
    right: ${(p) => (p.right ? "18px" : "auto")};
  }
`;
export const HeaderDropdownText = styled.div `
  padding: 10px;
  color: #fff;
`;
export const HeaderDropdownButton = styled.button `
  color: #fff;
  background: #0063ac;
  display: block;
  line-height: 40px;
  min-width: 300px;
  padding: 0 10px;
  border: 0;
  border-bottom: 1px solid #005493;
  text-align: left;

  :first {
    border-top: 1px solid #005493;
  }

  :hover {
    color: #fff;
    background: #005493;
  }

  .anticon {
    margin-right: 10px;
  }
`;
export const Layout = styled.section `
  display: flex;
  flex: auto;
  flex-direction: column;
  background: #f0f2f5;

  width: 100%;
  min-height: 100vh;
  padding-top: var(--opendash-header-height);
`;
export const Content = styled.main `
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  align-self: stretch;
  flex: auto;
  min-height: 0;
`;
export const Footer = styled.footer `
  flex: 0 0 auto;
  background: #f0f2f5;
`;
export const FooterRowCopyright = styled.div `
  text-align: center;

  height: 40px;
  line-height: 40px;

  * {
    font-size: 12px;
    color: darkgrey !important;
  }
`;
//# sourceMappingURL=data:application/json;base64,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